export default __webpack_public_path__ + "static/rewards-mobile-cebc72e67d52c40c12a13d623aca77da.svg";